var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttention(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.20083 0.750001C7.77818 -0.249998 9.22156 -0.250002 9.79891 0.749999L16.2941 12C16.8714 13 16.1498 14.25 14.9951 14.25H2.00468C0.849981 14.25 0.12829 13 0.705641 12L7.20083 0.750001ZM8.93288 1.25C8.74043 0.916667 8.25931 0.916666 8.06686 1.25L1.57167 12.5C1.37922 12.8333 1.61978 13.25 2.00468 13.25H14.9951C15.38 13.25 15.6205 12.8333 15.4281 12.5L8.93288 1.25Z",
    fill: "#2FD60A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20382 9.5112H8.80682L9.13982 5.5152V5.2002H7.86182V5.5152L8.20382 9.5112ZM7.90682 11.5002H9.10382V10.2672H7.90682V11.5002Z",
    fill: "#2FD60A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/Attention.7c3f46a9ddbd16c54e3c4ac399b0c4f6.svg";
export { ForwardRef as ReactComponent };